import { render, staticRenderFns } from "./input_surat_pemberitaan.vue?vue&type=template&id=efc6e098&"
import script from "./input_surat_pemberitaan.vue?vue&type=script&lang=js&"
export * from "./input_surat_pemberitaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports